export default __webpack_public_path__ + "static/media/startupMyths.png.webp";